function Hgvsc() {
  return (
    <div>
      <li className="bullet-item">
        Coding DNA reference sequence to describe variants (based on a protein coding transcript)
      </li>
    </div>
  );
}

export default Hgvsc;
